// extracted by mini-css-extract-plugin
module.exports = {"modal":"Alert_modal__3o0IU","icon":"Alert_icon__2JAk6","headerText":"Alert_headerText__1LWhU","text":"Alert_text__2wKOo","close":"Alert_close__3h05f"};